import type { ColumnDef } from '@tanstack/react-table';

import { DataTable, dateColumn, textColumn, numberColumn } from 'components/DataTable';
import { CREDIT_TYPE_LABELS } from 'pages/Credits/constants';
import { WalletFragmentFragment } from 'data/__generated__';
import { creditPath } from 'pages/Payments/components/PaymentIdLink';

type CreditRow = WalletFragmentFragment['credits'][number];

const columns: ColumnDef<CreditRow, unknown>[] = [
    dateColumn<CreditRow, Record<string, unknown>>({
        accessorKey: 'createdAt',
        header: 'Date de création',
        defaultVisible: true,
    }),
    dateColumn<CreditRow, Record<string, unknown>>({
        accessorKey: 'updatedAt',
        header: 'Dernière mise à jour',
        defaultVisible: true,
    }),
    textColumn<CreditRow, Record<string, unknown>>({
        id: 'createdBy',
        accessorFn: (row) => row.createdBy?.profile?.fullname || '',
        header: 'Créé par',
        defaultVisible: true,
    }),
    textColumn<CreditRow, Record<string, unknown>>({
        id: 'type',
        accessorFn: (row) => CREDIT_TYPE_LABELS[row.type],
        header: 'Type',
        defaultVisible: true,
    }),
    textColumn<CreditRow, Record<string, unknown>>({
        accessorKey: 'name',
        header: 'Nom du crédit',
        defaultVisible: true,
    }),
    numberColumn<CreditRow, Record<string, unknown>>({
        accessorKey: 'initialAmount',
        header: 'Montant initial',
        defaultVisible: true,
    }),
    numberColumn<CreditRow, Record<string, unknown>>({
        accessorKey: 'currentAmount',
        header: 'Montant restant',
        defaultVisible: true,
    }),
    dateColumn<CreditRow, Record<string, unknown>>({
        accessorKey: 'startDate',
        header: 'Date de début de validité',
        defaultVisible: true,
    }),
    dateColumn<CreditRow, Record<string, unknown>>({
        accessorKey: 'expirationDate',
        header: "Date d'expiration",
        defaultVisible: true,
    }),
];

export function Credits({ credits }: { credits: WalletFragmentFragment['credits'] }) {
    return (
        <DataTable<CreditRow>
            columns={columns}
            data={credits}
            filterMode="client"
            getRowId={(row) => row._id || ''}
            getRowLink={(row) => creditPath(row._id || '')}
            disableUrlSync
            autoFocusSearch={false}
        />
    );
}
